<template>
  <d2-container>
    <h2>用户管理</h2>
    <el-row>
      <el-form ref="elForm" size="medium" label-width="110px">
        <el-row type="flex" justify="start" align="top">
          <el-form-item label="用户姓名" prop="cityReq">
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;margin-right: 20px;" class="filter-item"
              placeholder="姓名或账户" v-model="listQuery.name" size="small"> </el-input>
          </el-form-item>
          <el-form-item size="large">
            <el-button size="small" class="filter-item" type="primary" icon="search"
              @click="handleFilter">查询</el-button>
            <el-button size="small" @click="resetForm">重置</el-button>
          </el-form-item>
        </el-row>
      </el-form>

      <el-button class="filter-item" v-permission:function="['userManager:btn_add']" style="margin-left: 10px;"
        @click="handleCreate" type="primary" size="mini" icon="el-icon-circle-plus">添加</el-button>
      <el-table :key='tableKey' :data="list" v-loading.body="listLoading" size="small" stripe highlight-current-row
        style="width: 100%;margin-top: 20px">
        <el-table-column align="center" label="序号" width="65"> <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template> </el-table-column>
        <el-table-column width="200" align="center" label="姓名"> <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template> </el-table-column>
        <el-table-column width="110" align="center" label="账户"> <template slot-scope="scope">
            <span>{{ scope.row.username }}</span>
          </template> </el-table-column>
        <el-table-column width="110" align="center" label="性别"> <template slot-scope="scope">
            <span>{{ scope.row.sex }}</span>
          </template> </el-table-column>
        <el-table-column width="200" align="center" label="政府或企业"> <template slot-scope="scope">
            <span>{{ scope.row.entName }}</span>
          </template> </el-table-column>
        <el-table-column width="200" align="center" label="所属部门"> <template slot-scope="scope">
            <span>{{ scope.row.departmentName }}</span>
          </template> </el-table-column>
        <el-table-column width="100" align="center" label="备注"> <template slot-scope="scope">
            <span>{{ scope.row.description }}</span>
          </template> </el-table-column>
        <el-table-column width="180" align="center" label="最后时间"> <template slot-scope="scope">
            <span>{{ scope.row.updTime }}</span>
          </template> </el-table-column>
        <el-table-column align="center" label="最后更新人"> <template slot-scope="scope">
            <span>{{ scope.row.updName }}</span>
          </template> </el-table-column>
        <el-table-column align="center" width="240" label="操作" fixed="right"> <template slot-scope="scope">
            <el-button v-permission:function="['userManager:btn_edit']" size="small" type="success"
              @click="handleUpdate(scope.row)">编辑
            </el-button>
            <el-button v-permission:function="['userManager:btn_del']" size="small" type="danger"
              @click="handleDelete(scope.row)">删除
            </el-button>
          </template> </el-table-column>
      </el-table>
      <!-- <div v-show="!listLoading" class="pagination-container"> -->
      <!--分页-->
      <div v-show="!listLoading" class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>

      <!-- </div> -->
      <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
          <el-row type="flex" justify="start" align="top">
            <el-col :span="10">
              <el-form-item label="所在机构" prop="entId">
                <el-select v-model="form.entId" placeholder="请选择" @change="getDepList" clearable style="width:202px;">
                  <el-option v-for="(item, index) in entList" :key="index" :label="item.entName" :value="item.entId"
                    :disabled="item.disabled"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="所属部门" prop="departmentId">
                <el-select v-model="form.departmentId" placeholder="请选择用户所在部门" clearable style="width:202px;">
                  <el-option v-for="(item, index) in depList" :key="index" :label="item.label" :value="item.id"
                    :disabled="item.disabled"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="start" align="top">
            <el-col :span="10">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="账户" prop="username">
                <el-input v-if="dialogStatus == 'create'" v-model="form.username" placeholder="请输入账户"></el-input>
                <el-input v-else v-model="form.username" placeholder="请输入账户" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="start" align="top">
            <el-col :span="12">
              <el-form-item label="密码" placeholder="请输入密码" prop="password">
                <div class="flex-row" style="height:40px;">
                  <el-input type="password" v-if="dialogStatus == 'create' || updatePasswordFlag"
                    v-model="form.password" autocomplete="new-password"></el-input>
                  <span v-if="dialogStatus != 'create'">
                    <i class="el-icon-edit oprBtn" @click="updatePasswordFlag = true" v-if="!updatePasswordFlag"></i>
                    <i class="el-icon-circle-close oprBtn" @click="updatePasswordFlag = false" v-else></i>
                  </span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别">
                <el-select class="filter-item" v-model="form.sex" placeholder="请选择">
                  <el-option v-for="item in sexOptions" :key="item" :label="item" :value="item"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="描述">
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" placeholder="请输入内容"
              v-model="form.description">
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel('form')">取 消</el-button>
          <el-button v-if="dialogStatus == 'create'" type="primary" @click="create('form')">确 定</el-button>
          <el-button v-else type="primary" @click="update('form')">确 定</el-button>
        </div>
      </el-dialog>
    </el-row>
  </d2-container>
</template>

<script>
import {
  pageList,
  page,
  addObj,
  getObj,
  delObj,
  putObj
} from '@/api/admin/user/index'
import {
  enterpriseAll
} from '@/api/admin/sysEnterprise/index'
import {
  fetchTree
} from '@/api/admin/group/index';
import { mapGetters } from 'vuex'
export default {
  name: 'userManager',
  data() {
    return {

      form: {
        username: undefined,
        name: undefined,
        sex: '男',
        password: undefined,
        description: undefined
      },
      rules: {
        entId: [
          {
            required: true,
            message: '请选择政府或企业',
            trigger: 'blur'
          }
        ], name: [
          {
            required: true,
            message: '请输入用户',
            trigger: 'blur'
          },
          {
            min: 2,
            max: 20,
            message: '长度在 2 到 20 个字符',
            trigger: 'blur'
          }
        ],
        username: [
          {
            required: true,
            message: '请输入账户',
            trigger: 'blur'
          },
          {
            min: 3,
            max: 20,
            message: '长度在 3 到 20 个字符',
            trigger: 'blur'
          }
        ],
        // password: [
        //   {
        //     required: true,
        //     message: '请输入密码',
        //     trigger: 'blur'
        //   },
        //   {
        //     min: 5,
        //     max: 20,
        //     message: '长度在 5 到 20 个字符',
        //     trigger: 'blur'
        //   }
        // ]
      },
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        name: undefined
      },
      sexOptions: ['男', '女'],
      entList: [],
      depList: [],
      dialogFormVisible: false,
      dialogStatus: '',
      userManager_btn_edit: this.hasPermissions(['userManager:btn_edit']),
      userManager_btn_del: false,
      userManager_btn_add: false,
      textMap: {
        update: '编辑',
        create: '创建'
      },
      tableKey: 0,
      updatePasswordFlag: false,
    }
  },
  created() {
    this.getList()
    this.getEntList();
    this.getDepList();
  },
  computed: {
    ...mapGetters([
      'elements'
    ])
  },
  methods: {
    getList() {
      this.listLoading = true
      pageList(this.listQuery)
        .then(response => {
          this.list = response.rows
          this.total = response.total
          this.listLoading = false
        })
    },
    getEntList() {
      enterpriseAll({}).then(response => {
        this.entList = response;
      })
    },
    getDepList(entId) {
      fetchTree({ groupType: 2, entId: entId }).then(data => {
        this.depList = data
      })
    },
    handleFilter() {
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
    },
    handleUpdate(row) {
      getObj(row.id)
        .then(response => {
          this.form = response;
          this.getDepList(this.form.entId);
          this.dialogFormVisible = true
          this.dialogStatus = 'update'
        })
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delObj(row.id)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '删除成功',
                type: 'success',
                duration: 2000
              })
              const index = this.list.indexOf(row)
              this.list.splice(index, 1)
            })
        })
    },
    create(formName) {
      const set = this.$refs
      set[formName].validate(valid => {
        if (valid) {
          addObj(this.form)
            .then(() => {
              this.dialogFormVisible = false
              this.getList()
              this.$notify({
                title: '成功',
                message: '创建成功',
                type: 'success',
                duration: 2000
              })
            })
        } else {
          return false
        }
      })
    },
    cancel(formName) {
      this.dialogFormVisible = false
      this.$refs[formName].resetFields()
    },
    update(formName) {
      const set = this.$refs
      set[formName].validate(valid => {
        if (valid) {
          this.dialogFormVisible = false
          putObj(this.form.id, this.form).then(() => {
            this.dialogFormVisible = false
            this.getList()
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            })
          })
        } else {
          return false
        }
      })
    },
    resetTemp() {
      this.form = {
        username: undefined,
        name: undefined,
        sex: '男',
        password: undefined,
        description: undefined
      }
    }
  }
}
</script>
<style scoped>
.flex-row {
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
}

.oprBtn {
  cursor: pointer;
  margin: 0 4px;
}
</style>